import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import FutureReadySection from './components/FutureReadySection';
import EnergySystemDiagram from './components/EnergySystemDiagram';
import WhySunprojectsSection from './components/WhySunprojectsSection';
import ComparisonSection from './components/ComparisonSection';
import FounderSection from './components/FounderSection';
import ReferenceSection from './components/ReferenceSection';
import CustomerReviewsSection from './components/CustomerReviewsSection';
import EconomicBenefitSection from './components/EconomicBenefitSection';
import RegionalExpertSection from './components/RegionalExpertSection';
import AutarkieCalculator from './components/AutarkieCalculator';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import StickyContactButton from './components/StickyContactButton';
import ImpressumPage from './components/ImpressumPage';
import DatenschutzPage from './components/DatenschutzPage';
import NoticePopup from './components/NoticePopup';

// Main Landing Page Component
const LandingPage = () => (
  <>
    <NoticePopup />
    <CookieBanner />
    <Header />
    <main>
      <HeroSection />
      <TrustSection />
      <ProblemSection />
      <SolutionSection />
      <FutureReadySection />
      <EnergySystemDiagram />
      <WhySunprojectsSection />
      <ComparisonSection />
      <FounderSection />
      <ReferenceSection />
      <CustomerReviewsSection />
      <EconomicBenefitSection />
      <RegionalExpertSection />
      <AutarkieCalculator />
      <ProcessSection />
      <FAQSection />
      <ContactSection />
    </main>
    <Footer />
    <StickyContactButton />
  </>
);

function App() {
  return (
    <Router>
      <div className="App" data-testid="app-root">
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
